module.exports = __webpack_public_path__ + "img/insta-ease.76f1375a.svg";